import React from "react";
import Footer from "../Footer";
import Topbar from "../Topbar";

export default function BaseLayout({ children }) {
  return (
    <div className="w-full h-full">
      <div className="absolute w-full z-50">
        <Topbar />
      </div>

      {children}

      <div className="">
        <Footer />
      </div>
    </div>
  );
}
